import { Breadcrumbs, Link } from "@mui/material"

interface IProps {
  links: {
    href: string
    title?: string | null
    icon?: JSX.Element
  }[]
}

const BreadCrumbs = ({links}: IProps) => {

  return (
    <div role="presentation">
      <Breadcrumbs sx={{fontSize: 15}}>
        {
          links.map((link, index) =>
            <Link
              color={index + 1 === links.length ? "primary" : "inherit"}
              underline="hover"
              sx={{display: "flex", alignItems: "center"}}
              href={`/fbl${link.href}`}
            >
              {link.icon}
              {link.title}
            </Link>
          )
        }
      </Breadcrumbs>

    </div>
  )
}

export default BreadCrumbs